<template>
    <ResultCardContainer :header-title="t('results.tournamentPayouts.cardTitle')">
        <FlexContainer
            :flex-direction="flexDirection.column"
        >
            <Typography
                :variant="typographyVariants.label"
                :weight="typographyWeights.regular"
                :color="typographyColors.greyMedium"
            >
                {{ t('results.tournamentPayouts.prizePool') }}
            </Typography>
            <SpacingClassWrapper
                :padding-top="1"
            >
                <Typography
                    :variant="typographyVariants.body"
                    :weight="typographyWeights.regular"
                    :color="typographyColors.dark"
                    :size="typographySizes.title"
                >
                  {{ tournamentPayouts.prizePool | currencyString }}
                </Typography>
            </SpacingClassWrapper>
        </FlexContainer>
        <SpacingClassWrapper
            :padding-right="0"
            :margin-top="$mq | mq({ sm: 6, md: 6, pccFullSize: 4 })"
        >
            <TableScrollContainer
                :table-height-px="$mq | mq({
                    sm: 355,
                    md: 300
                })"
                :table-headers="tableHeaders"
                :table-headers-align="tableCellAlign.left"
                :scroll-visibility="scrollbarApperance.visible"
                :tableHeadersSize="typographySizes.label"
                :color="typographyColors.dark"
            >
                <tr
                    v-for="(item, index) in tournamentPayouts.payoutValues"
                    :key="index"
                >
                    <SpacingClassWrapper
                          :padding-bottom="0"
                          :padding-top="1">
                          <TableCell
                              :variant="tableCellVariants.standard"
                              :text-align="tableCellAlign.left"
                          >
                            <FlexContainer
                                :flex-direction="flexDirection.row"
                                :align-items="flexAlignItems.center"
                                :justify-content="flexJustifyContent.spaceBetween"
                            >
                                <Typography
                                    :variant="typographyVariants.heading3"
                                    :weight="typographyWeights.regular"
                                    :color="typographyColors.dark"
                                >
                                    {{index + 1}}{{getPlaceLabel(index)}} place
                                </Typography>
                                <Typography
                                    :variant="typographyVariants.heading3"
                                    :weight="typographyWeights.regular"
                                    :color="typographyColors.dark"
                                >
                                    {{ item | currencyString }}
                                </Typography>
                            </FlexContainer>
                          </TableCell>
                      </SpacingClassWrapper>
                </tr>
            </TableScrollContainer>
        </SpacingClassWrapper>
    </ResultCardContainer>
</template>

<script>
// Components
import Typography from '../../components/Typography';
import TableCell from '../../components/TableCell';

//Containers
import ResultCardContainer from '../../containers/results/ResultCardContainer';
import TableScrollContainer from '../../containers/generic/TableScrollContainer';
import FlexContainer from '../../containers/flex/FlexContainer';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';

// Types
import {
    typographyVariants,
    typographyColors,
    typographyWeights,
    typographyTransform,
    typographySizes
} from '../../types/Typography.types';
import { flexDirection, flexWrap, flexAlignItems, flexJustifyContent } from '../../types/Flex.types';
import { scrollbarApperance, scrollbarApperanceDefault } from '../../types/ScrollFlex.types';
import { tableCellVariants, tableCellAlign } from '../../types/TableCell.types'

// Mixins
import styles from '../../mixins/styles.js';
import translations from '../../mixins/translations.js';

// Vuex
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    name: 'TournamentPayoutsLayout',
    components: {
        // Components
        Typography,
        TableCell,
        // Class Wrappers
        SpacingClassWrapper,
        // Containers
        ResultCardContainer,
        TableScrollContainer,
        FlexContainer
    },
    mixins: [styles, translations],
    data: function () {
        return {
            typographyVariants,
            typographyColors,
            typographyWeights,
            typographyTransform,
            typographySizes,
            flexDirection,
            flexWrap,
            flexAlignItems,
            flexJustifyContent,
            scrollbarApperance,
            tableCellAlign,
            tableCellVariants,
        }
    },
    computed: {
        ...mapGetters([
            'tournamentPayouts',
        ]),
        listStyle: function() {
            return {
                height: '250px'
            }
        },
        customHeadingStyle: function() {
            return {
                minHeight: '44px'
            }
        },
        tableHeaders: function() {
            return [
                this.t('results.tournamentPayouts.listCaption'),
            ]
        },
    },
    methods: {
        getPlaceLabel: function(index) {
            const placeLabel= {
                1: 'st',
                2: 'nd',
                3: 'rd',
                'default': 'th'
            }
            return placeLabel[index + 1] ? placeLabel[index + 1] : placeLabel['default']
        },
        isFirstRow: function(index) {
            return index === 0
        }
    }
};
</script>
